<template>
  <b-media
    class="notification-card "
    :class="(!notification.isRead && unReadNotifications!=0) && 'notification-card--active'"
  >
    <template #aside>
      <b-avatar
        size="42"
        :variant="displayNotification.type"
        :src="getAvatar(displayNotification.avatar)"
      >
        <feather-icon
          v-if="!displayNotification.avatar"
          :icon="displayNotification.icon"
        />
      </b-avatar>
    </template>
    <p class="media-heading d-flex align-items-center mb-0">
      <span class="font-weight-bolder">
        {{ displayNotification.title }}
      </span>
      <feather-icon
        v-if="!notification.isRead && unReadNotifications!=0"
        icon="CircleIcon"
        size="8"
        fill="#3D61AD"
        class="ml-1 text-primary"
      />
    </p>
    <small
      class="notification-text"
      v-html="displayNotification.subtitle"
    />
    <div class="text-right">
      <small class="text-mute">
        {{ fromNow(UTCtoLocal(displayNotification.createdAt)) }}
      </small>
    </div>
  </b-media>
</template>
<script>
import { BMedia, BAvatar } from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BMedia,
    BAvatar,
  },
  props: {
    notification: {
      type: [Array, Object],
      default: () => {},
    },
    unReadNotifications: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      currentUser: getUserData(),
    }
  },
  computed: {
    displayNotification() {
      const {
        isRead, uuid, createdAt, notification,
      } = this.notification
      const creatorName = notification.updatedBy?.uuid === this.currentUser.uuid ? 'you' : `${notification.updatedBy?.name || 'Someone'}`

      const title = 'Mentioned You!'
      const subtitle = `You were mentioned in task <strong>"${notification.task.title}"</strong> by ${creatorName}.`
      return {
        title, subtitle, type: 'light-success', icon: 'UserIcon', avatar: notification.updatedBy?.avatar, isRead, uuid, createdAt,
      }
    },
  },
}
</script>
